import React from 'react';
import Slide1 from './static/slide-1/slide-1';
import Slide2 from './static/slide-2/slide-2';
import Slide3 from './static/slide-3/slide-3';
import Slide4 from './static/slide-4/slide-4';
import Slide5 from './static/slide-5/slide-5';

const carouselSlides = [
    {
        slide: <Slide1 />,
        title: 'tripboards.main.empty.startplan'
    },
    {
        slide: <Slide2 />,
        mobileTitle: 'tripboards.main.empty.heart',
        title: 	'tripboards.main.empty.heart.desktop'
    },
    {
        slide: <Slide3 />,
        title: 'tripboards.main.empty.invite'
    },
    {
        slide: <Slide4 />,
        title: 'tripboards.main.empty.comment'
    },
    {
        slide: <Slide5 />,
        title: 'tripboards.main.empty.planning'
    }
];

export default carouselSlides;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/index.js